module.exports = __webpack_public_path__ + "img/hosp.e428ce4b.jpg";